export const BiomaEnum = {
    AMAZONIA: {
        id: 'AMAZONIA',
        nome: 'Amazônia',
    },
    CERRADO: {
        id: 'CERRADO',
        nome: 'Cerrado',
    },
    MATA_ATLANTICA: {
        id: 'MATA_ATLANTICA',
        nome: 'Mata Atlântica',
    },
    CAATINGA: {
        id: 'CAATINGA',
        nome: 'Caatinga',
    },
    PANTANAL: {
        id: 'PANTANAL',
        nome: 'Pantanal',
    },
    PAMPA: {
        id: 'PAMPA',
        nome: 'Pampa',
    }
};

export const AreaEnum = {
    APP: {
        id: 'APP',
        nome: 'Área de Preservação Permanente',
    },
    RL: {
        id: 'RL',
        nome: 'Área Reserva Legal',
    },
    AUR: {
        id: 'AUR',
        nome: 'Área de Uso Restrito - AUR'
    }
};

export const TipoImovelEnum = {
    IRU: {
        id: 'IRU',
        nome: 'Imóvel Rural',
    },
    PCT: {
        id: 'PCT',
        nome: 'Território Tradicional de Povos e Comunidades Tradicionais',
    },
    AST: {
        id: 'AST',
        nome: 'Imóvel Rural de Assentamentos da Reforma Agrária'
    }
};
